import { render, staticRenderFns } from "./ReferenceLinkForm.vue?vue&type=template&id=17e36d7a&"
import script from "./ReferenceLinkForm.vue?vue&type=script&lang=js&"
export * from "./ReferenceLinkForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports